<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改定制单' : '新增定制单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="110px"
        ref="editOrderFormRef"
        :rules="{
          orderDate: this.$ruleUtil.simple({
            fieldName: '单据日期',
            handleType: '选择',
            required: true,
          }),
          customerId: this.$ruleUtil.simple({
            fieldName: '客户',
            handleType: '选择',
            required: true,
          }),
          customerName: this.$ruleUtil.simple({
            fieldName: '联系人姓名',
            required: true,
            max: 50,
          }),
          customerPhoneNumber: this.$ruleUtil.simple({
            fieldName: '联系方式',
            required: true,
            max: 20,
          }),
          customerAddress: this.$ruleUtil.simple({
            fieldName: '联系地址',
            required: true,
            max: 20,
          }),
          collectVoucherSysFileIdList: this.$ruleUtil.array(
            '收款凭证',
            '上传',
            orderConfig.collectOrderCollectVoucherRequired ? 1 : 0,
            10
          ),
          saleUserIdList: this.$ruleUtil.array('业务员', '选择', 1),
          totalQuantity: this.$ruleUtil.number(
            '商品数量',
            this.quantityMinLimit,
            1000
          ),
        }"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="customerId">
          <CustomerSelect
            :value="customer"
            @select="selectCustomer"
          ></CustomerSelect>
        </el-form-item>
        <el-row :gutter="10" v-if="headInfo.customerId">
          <el-col :span="6">
            <el-form-item label="联系人信息" prop="customerId">
              <el-input
                v-model="headInfo.customerName"
                placeholder="请输入联系人姓名"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerPhoneNumber"
                placeholder="请输入联系方式"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerAddress"
                placeholder="请输入联系地址"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="定制商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未添加商品</span>
            <span>，总零售价：</span>
            <FmAmount :amount="headInfo.buyingTotalAmount"></FmAmount>
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            prop="commodityName"
            label="名称"
            width="180"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input
                size="mini"
                placeholder="请输入商品名称"
                v-model="scope.row.commodityName"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="220"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input
                type="textarea"
                size="mini"
                placeholder="请输入商品备注"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-model="scope.row.remark"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileList"
            label="相关图片"
            width="200"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div
                class="fm-rela fm-uploadDiv-50"
                v-for="(file, index) in scope.row.fileList"
                :key="index"
              >
                <el-image
                  :id="'itemCommodityImage-' + scope.row.itemNo + '-' + index"
                  :src="file.url"
                  :preview-src-list="scope.row.fileList.map((d) => d.url)"
                  :initial-index="index"
                  alt=""
                />
                <div
                  class="LoadingIcon fm-center"
                  v-if="file.status == 'ready'"
                >
                  <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
                </div>
                <div class="HandleIcon">
                  <i
                    @click="
                      itemCommodityImageFilePreview(scope.row.itemNo, index)
                    "
                    alt="预览图片"
                    class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
                  ></i>
                  <i
                    alt="删除图片"
                    @click="
                      itemCommodityImageFileDelete(
                        scope.row.itemNo,
                        index,
                        file
                      )
                    "
                    class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
                  ></i>
                </div>
              </div>
              <el-upload
                :action="
                  $envConfig.VUE_APP_uploadCustomizeOrderCommodityImage + ''
                "
                :headers="{
                  AuthorityToken: $storageUtil.getAuthorityToken(),
                }"
                :limit="10"
                multiple
                accept="image/*"
                :file-list="scope.row.fileList"
                :show-file-list="false"
                :on-change="
                  (a, b) => itemCommodityImageChange(scope.row.itemNo, a, b)
                "
                :on-success="
                  (a, b) => itemCommodityImageSuccess(scope.row.itemNo, a, b)
                "
                :on-exceed="() => this.$message.warning('最多上传10张图片')"
                v-if="scope.row.fileList.length < 10"
              >
                <div slot="default" class="fm-center fm-uploadDiv-50">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingPrice"
            label="零售单价"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 120px"
                v-model="scope.row.buyingPrice"
                size="mini"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="商品数量"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                style="width: 120px"
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="mini"
                :max="1000"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            width="130"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input
                style="width: 120px"
                size="mini"
                placeholder="请输入商品单位"
                v-model="scope.row.unit"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingTotalAmount"
            label="总零售价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.buyingTotalAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingDisCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.buyingDisCountAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemBuyingAmount"
            label="成交价"
            width="140"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 130px"
                v-model="scope.row.itemBuyingAmount"
                size="mini"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.buyingTotalAmount == 'string'
                    ? Number(scope.row.buyingTotalAmount)
                    : scope.row.buyingTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="extFieldValueAddNewPojoList"
            label="拓展字段"
            width="350"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.extFieldValueAddNewPojoList &&
                  scope.row.extFieldValueAddNewPojoList.length > 0
                "
              >
                <el-row
                  v-for="(rowItem, rowFiIndex) in $jsTool.groupArray(
                    scope.row.extFieldValueAddNewPojoList,
                    1
                  )"
                  :key="rowFiIndex"
                >
                  <el-col
                    :span="8"
                    v-for="(item, fiIndex) in rowItem"
                    :key="fiIndex"
                  >
                    <el-form-item
                      :class="item.visible ? '' : 'deleteFormItem'"
                      :label="item.label"
                      :required="item.requiredMark && item.visible"
                      style="margin-bottom: 10px"
                      label-width="100px"
                    >
                      <span
                        style="color: var(--fm-warning-color)"
                        v-if="!item.visible"
                        >已删除</span
                      >
                      <template v-else>
                        <template v-if="item.extFieldTypeEnum == 'Input'">
                          <el-input
                            size="mini"
                            type="text"
                            :placeholder="item.configObj.placeholder"
                            :maxlength="item.configObj.maxlength"
                            v-model="item.value"
                            show-word-limit
                            style="width: 200px"
                          >
                          </el-input>
                        </template>
                        <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                          <el-input-number
                            size="mini"
                            inputWidth="100"
                            v-model="item.value"
                            :placeholder="item.configObj.placeholder"
                            :max="item.configObj.max"
                            :min="item.configObj.min"
                            :step="item.configObj.step"
                            :precision="item.configObj.precision"
                            style="width: 200px"
                          ></el-input-number>
                        </template>
                        <template v-if="item.extFieldTypeEnum == 'Radio'">
                          <el-radio-group v-model="item.value">
                            <el-radio
                              v-for="(check, index) in item.configObj.list"
                              :key="index"
                              size="mini"
                              :label="check.label"
                              :name="check.label"
                              style="
                                height: 32px;
                                align-content: space-around;
                                width: 200px;
                              "
                            ></el-radio>
                          </el-radio-group>
                        </template>
                        <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                          <el-checkbox-group v-model="item.value">
                            <el-checkbox
                              v-for="(check, index) in item.configObj.list"
                              :key="index"
                              size="mini"
                              :label="check.label"
                              :name="check.label"
                            ></el-checkbox>
                          </el-checkbox-group>
                        </template>
                        <template v-if="item.extFieldTypeEnum == 'Select'">
                          <el-select
                            v-model="item.value"
                            :placeholder="item.configObj.placeholder"
                            size="mini"
                            style="width: 200px"
                          >
                            <el-option
                              v-for="option in item.configObj.list"
                              :key="option.no"
                              size="mini"
                              :label="option.label"
                              :value="option.label"
                            >
                            </el-option>
                          </el-select>
                        </template>
                        <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                          <el-date-picker
                            size="mini"
                            placeholder="请选择"
                            v-model="item.value"
                            :type="item.configObj.format"
                            :value-format="
                              item.configObj.format == 'datetime'
                                ? 'yyyy-MM-dd HH:mm:ss'
                                : 'yyyy-MM-dd'
                            "
                            style="width: 200px"
                          >
                          </el-date-picker>
                        </template>
                      </template>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <span v-fmtype="'warning'" v-else>暂无拓展字段</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                @click.native.stop="addItem(scope.$index)"
                type="text"
                icon="el-icon-plus"
              >
                增加
              </el-button>
              <el-popconfirm
                title="是否删除所选商品？"
                :disabled="itemList.length == 1"
                @confirm="deleteItem(scope.$index)"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-delete"
                  v-fmtype="itemList.length == 1 ? 'info' : 'error'"
                  :disabled="itemList.length == 1"
                  @click.native.stop
                >
                  删除
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item
          label="优惠金额"
          prop="buyingDisCountAmount"
          class="fm-mt-10"
        >
          <div class="fm-flex" style="height: 32px">
            <FmAmount :amount="headInfo.buyingDisCountAmount"></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="商品零售成交价" prop="buyingAmount">
          <el-input-number
            v-model="headInfo.buyingAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="Number(headInfo.buyingTotalAmount)"
            :step="1"
            style="width: 180px"
            @change="changeCommodityBuyingAmount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="其他费用">
          <div class="fm-flex">
            <el-switch
              v-model="hasOtherExpenseAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasOtherExpenseAmount"
            >
            </el-switch>
            <p
              v-fmtype="'success'"
              class="fm-ml-10"
              v-if="hasOtherExpenseAmount"
            >
              有其他费用
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无其他费用</span>
            <p class="fm-ml-10" v-if="hasOtherExpenseAmount">其他费用合计：</p>
            <FmAmount
              :amount="headInfo.otherExpenseAmount"
              v-if="hasOtherExpenseAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasOtherExpenseAmount">
          <el-table
            :data="headInfo.orderOtherExpenseAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'otherExpenseAmount' + otherExpenseAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  maxlength="20"
                  show-word-limit
                  placeholder="请输入金额说明"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="
                    itemOrderOtherExpenseAmountChange(scope.$index, scope.row)
                  "
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addOrderOtherExpenseItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选其他费用？"
                  :disabled="
                    headInfo.orderOtherExpenseAddNewPojoList.length == 1
                  "
                  @confirm="deleteOrderOtherExpenseItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.orderOtherExpenseAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="
                      headInfo.orderOtherExpenseAddNewPojoList.length == 1
                    "
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="单据金额" prop="orderAmount">
          <div class="fm-flex" style="height: 32px">
            <span>
              <FmAmount :amount="headInfo.orderAmount"></FmAmount>
            </span>
          </div>
        </el-form-item>

        <el-form-item label="现结金额" class="fm-mt-10">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">现结金额说明</div>
              现结金额为制单时已经收款的金额，填写时不得大于定制单的单据金额<br />销售单审批通过后，自动根据已填写的现结信息生成收款单并自动审批通过
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>现结金额</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="hasSettledAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasSettledAmount"
            >
            </el-switch>
            <p v-fmtype="'success'" class="fm-ml-10" v-if="hasSettledAmount">
              有现结金额
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无现结金额</span>
            <p class="fm-ml-10" v-if="hasSettledAmount">现结金额合计：</p>
            <FmAmount
              :amount="headInfo.settledAmount"
              v-if="hasSettledAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasSettledAmount">
          <el-table
            :data="headInfo.fundAccountAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'settledAmount' + settledAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="资金账户"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <FundAccountSelect
                  :value="scope.row.fundAccount"
                  @select="
                    (e) => {
                      selectFundAccount(e, scope.$index);
                    }
                  "
                ></FundAccountSelect>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="itemFundAccountAmountChange(scope.$index, scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addFundAccountItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选现结金额？"
                  :disabled="headInfo.fundAccountAddNewPojoList.length == 1"
                  @confirm="deleteFundAccountItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.fundAccountAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="headInfo.fundAccountAddNewPojoList.length == 1"
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item
          label="收款凭证"
          class="fm-mt-10"
          prop="collectVoucherSysFileIdList"
          v-if="hasSettledAmount"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in collectVoucherFileList"
            :key="index"
          >
            <el-image
              :id="'collectVoucherImage' + index"
              :src="file.url"
              :preview-src-list="collectVoucherFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="collectVoucherFilePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="collectVoucherFileDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadCustomizeOrderCollectVoucher + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="collectVoucherFileList"
            :show-file-list="false"
            :on-change="collectVoucherFileChange"
            :on-success="collectVoucherFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="collectVoucherFileList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="收款备注"
          prop="collectRemark"
          v-if="hasSettledAmount"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.collectRemark"
            style="width: 400px"
            placeholder="请输入收款备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="其他成本" class="fm-mt-10">
          <div class="fm-flex">
            <el-switch
              v-model="hasOtherCostAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasOtherCostAmount"
            >
            </el-switch>
            <p v-fmtype="'success'" class="fm-ml-10" v-if="hasOtherCostAmount">
              有其他成本
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无其他成本</span>
            <p class="fm-ml-10" v-if="hasOtherCostAmount">其他成本合计：</p>
            <FmAmount
              :amount="headInfo.otherCostAmount"
              v-if="hasOtherCostAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasOtherCostAmount">
          <el-table
            :data="headInfo.orderOtherCostAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'otherCostAmount' + otherCostAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  maxlength="20"
                  show-word-limit
                  placeholder="请输入金额说明"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="
                    itemOrderOtherCostAmountChange(scope.$index, scope.row)
                  "
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addOrderOtherCostItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选其他成本？"
                  :disabled="headInfo.orderOtherCostAddNewPojoList.length == 1"
                  @confirm="deleteOrderOtherCostItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.orderOtherCostAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="
                      headInfo.orderOtherCostAddNewPojoList.length == 1
                    "
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div v-if="headInfo.extFieldValueAddNewPojoList.length > 0">
          <div style="height: 10px"></div>
          <el-divider content-position="left">
            <span style="font-weight: bold">拓展字段</span>
          </el-divider>
          <div style="height: 20px"></div>
          <el-row
            v-for="(rowItem, rowFiIndex) in $jsTool.groupArray(
              headInfo.extFieldValueAddNewPojoList,
              3
            )"
            :key="rowFiIndex"
          >
            <el-col :span="8" v-for="(item, fiIndex) in rowItem" :key="fiIndex">
              <el-form-item
                :class="item.visible ? '' : 'deleteFormItem'"
                :label="item.label"
                :required="item.requiredMark && item.visible"
                style="margin-bottom: 10px"
              >
                <span
                  style="color: var(--fm-warning-color)"
                  v-if="!item.visible"
                  >已删除</span
                >
                <template v-else>
                  <template v-if="item.extFieldTypeEnum == 'Input'">
                    <el-input
                      type="text"
                      :placeholder="item.configObj.placeholder"
                      :maxlength="item.configObj.maxlength"
                      v-model="item.value"
                      show-word-limit
                      style="width: 200px"
                    >
                    </el-input>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                    <el-input-number
                      inputWidth="100"
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                      :max="item.configObj.max"
                      :min="item.configObj.min"
                      :step="item.configObj.step"
                      :precision="item.configObj.precision"
                      style="width: 200px"
                    ></el-input-number>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Radio'">
                    <el-radio-group v-model="item.value">
                      <el-radio
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                        style="height: 32px; align-content: space-around"
                      ></el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                    <el-checkbox-group v-model="item.value">
                      <el-checkbox
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                    >
                      <el-option
                        v-for="option in item.configObj.list"
                        :key="option.no"
                        :label="option.label"
                        :value="option.label"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                    <el-date-picker
                      v-model="item.value"
                      :type="item.configObj.format"
                      :value-format="
                        item.configObj.format == 'datetime'
                          ? 'yyyy-MM-dd HH:mm:ss'
                          : 'yyyy-MM-dd'
                      "
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </template>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizeOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },

  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            await this.getExtFieldList();
            await this.getItemExtFieldList();
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
            this.$refs.editOrderFormRef.validateField("itemQuantity");
          }, 100);
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        collectOrderCollectVoucherRequired: true,
      },

      hasOtherExpenseAmount: false,
      otherExpenseAmountKey: "null",

      hasSettledAmount: false,
      settledAmountKey: "null",

      hasOtherCostAmount: false,
      otherCostAmountKey: "null",

      itemQuantityKey: "null",

      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        customerId: null,
        customerName: null,
        customerPhoneNumber: null,
        customerAddress: "",
        saleUserIdList: [],

        buyingTotalAmount: "0.00",
        buyingDisCountAmount: "0.00",
        buyingAmount: "0.00",

        orderAmount: "0.00",

        totalQuantity: 1,

        settledAmount: "0.00",
        fundAccountAddNewPojoList: [
          {
            itemNo: 1,
            fundAccountId: null,
            itemAmount: "0.00",
            remark: "",
          },
        ],
        collectVoucherSysFileIdList: [],
        collectRemark: "",

        otherExpenseAmount: "0.00",
        orderOtherExpenseAddNewPojoList: [
          {
            itemNo: 1,
            name: null,
            itemAmount: "0.00",
          },
        ],

        otherCostAmount: "0.00",
        orderOtherCostAddNewPojoList: [
          {
            itemNo: 1,
            name: null,
            itemAmount: "0.00",
          },
        ],
        remark: "",
        extFieldValueAddNewPojoList: [],
      },
      itemList: [],
      customer: {},
      saleUserList: [],

      commoditySelectDialogShow: false,

      collectVoucherFileList: [],

      quantityMinLimit: 0.001,

      // 拓展字段
      extFieldList: [],
      itemExtFieldList: [],

      editItem: {
        itemNo: 0,
        commodityName: "",
        remark: "",
        unit: "件",
        sysFileIdList: [],
        fileList: [],
        itemQuantity: 1,
        buyingPrice: "0.00",
        buyingTotalAmount: "0.00",
        buyingDisCountAmount: "0.00",
        itemBuyingAmount: "0.00",
        extFieldValueAddNewPojoList: [],
      },
    };
  },

  mounted() {},

  methods: {
    async getExtFieldList() {
      let res = await this.$api.extField_findAvailableList("CustomizeOrder");
      if (res && res.success) {
        this.extFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },
    async getItemExtFieldList() {
      let res = await this.$api.extField_findAvailableList(
        "CustomizeOrderItem"
      );
      if (res && res.success) {
        this.itemExtFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },

    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
      this.headInfo.extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(this.extFieldList || [])
      );
      this.editItem.extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(this.itemExtFieldList || [])
      );
      this.itemList = [this.editItem];
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizeOrder:NeedApproval",
        "Order:CustomizeOrder:EditCustomer",
        "Order:CustomizeCollectOrder:PaperOrderRequired",
        "Order:CustomizeCollectOrder:CollectVoucherRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let paperOrderIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeCollectOrder:PaperOrderRequired"
        );
        let collectVoucherIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeCollectOrder:CollectVoucherRequired"
        );
        if (
          paperOrderIndex > -1 &&
          res.data[paperOrderIndex].value == "false" &&
          collectVoucherIndex > -1 &&
          res.data[collectVoucherIndex].value == "false"
        ) {
          this.orderConfig.collectOrderCollectVoucherRequired = false;
        }
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },

    selectCustomer(item) {
      this.headInfo.customerId = item.id;
      this.headInfo.customerName = item.name;
      this.headInfo.customerPhoneNumber = item.phoneNumber;
      this.headInfo.customerAddress = item.address;
      this.customer = item;
      this.$message({
        message: "已自动更新联系人信息",
        type: "success",
      });
    },

    selectFundAccount(item, index) {
      this.headInfo.fundAccountAddNewPojoList.splice(index, 1, {
        ...this.headInfo.fundAccountAddNewPojoList[index],
        fundAccount: item,
        fundAccountId: item.id,
      });
      this.settledAmountKey = Math.random();
    },

    // 选择商品
    selectCommodity(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;

      this.headInfo.buyingTotalAmount = this.$jsTool.sum(
        list.map((d) => d.buyingTotalAmount)
      );
      this.headInfo.buyingDisCountAmount = this.$jsTool.sum(
        list.map((d) => d.buyingDisCountAmount)
      );
      this.headInfo.buyingAmount = this.$jsTool.sub(
        this.headInfo.buyingTotalAmount,
        this.headInfo.buyingDisCountAmount
      );

      this.headInfo.orderAmount = this.$jsTool.add(
        this.headInfo.buyingAmount,
        this.headInfo.otherExpenseAmount
      );

      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
    },
    changeItemPrice(index, row) {
      if (!row.buyingPrice) {
        row.buyingPrice = "0.00";
      }
      let buyingTotalAmount = this.$jsTool.multi(
        row.buyingPrice,
        row.itemQuantity
      );
      row = {
        ...row,
        buyingTotalAmount: buyingTotalAmount,
        buyingDisCountAmount: 0,
        itemBuyingAmount: buyingTotalAmount,
      };
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      if (!value) {
        value = 0;
      }
      if (value == 0) {
        if (this.itemList.length == 1) {
          this.$message({
            message: "最少保留一条商品信息",
            type: "error",
          });
          row.itemQuantity = 1;
          this.itemQuantityKey = Math.random();
        } else {
          this.$confirm("是否移除所选商品?", "操作提醒", {
            confirmButtonText: "移除",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          })
            .then(() => {
              this.itemList.splice(index, 1);
              this.$nextTick(() => {
                this.changeItemAfterHandle(index);
              });
            })
            .catch(() => {
              row.itemQuantity = 1;
              this.itemQuantityKey = Math.random();
            });
        }
      } else {
        let buyingTotalAmount = this.$jsTool.multi(row.buyingPrice, value);
        row = {
          ...row,
          itemQuantity: value,
          buyingTotalAmount: buyingTotalAmount,
          buyingDisCountAmount: 0,
          itemBuyingAmount: buyingTotalAmount,
        };
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (
        (row.itemBuyingAmount || Number(row.itemBuyingAmount) == 0) &&
        (row.buyingTotalAmount || Number(row.buyingTotalAmount) == 0)
      ) {
        row.buyingDisCountAmount = this.$jsTool.sub(
          row.buyingTotalAmount,
          row.itemBuyingAmount
        );
      } else {
        row.buyingDisCountAmount = "0.00";
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCommodity(this.itemList);
        return;
      }
      this.itemList.splice(index, 1, row);
      this.selectCommodity(this.itemList);
      this.$forceUpdate();
    },

    // 其他费用相关
    itemOrderOtherExpenseAmountChange() {
      this.headInfo.otherExpenseAmount = this.$jsTool.sum(
        this.headInfo.orderOtherExpenseAddNewPojoList.map(
          (item) => item.itemAmount
        )
      );
      this.selectCommodity(this.itemList);
    },
    handleHasOtherExpenseAmount(e) {
      if (e) {
        if (
          !this.headInfo.orderOtherExpenseAddNewPojoList ||
          this.headInfo.orderOtherExpenseAddNewPojoList.length == 0
        ) {
          this.headInfo.orderOtherExpenseAddNewPojoList = [
            {
              itemNo: 1,
              name: null,
              itemAmount: "0.00",
            },
          ];
        }
        this.itemOrderOtherExpenseAmountChange();
      } else {
        this.headInfo.otherExpenseAmount = "0.00";
        this.selectCommodity(this.itemList);
      }
    },
    addOrderOtherExpenseItem(index) {
      this.headInfo.orderOtherExpenseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.orderOtherExpenseAddNewPojoList[
            this.headInfo.orderOtherExpenseAddNewPojoList.length - 1
          ].itemNo + 1,
        name: null,
        itemAmount: "0.00",
      });
      this.resetOrderOtherExpenseItemNo();
    },
    deleteOrderOtherExpenseItem(index) {
      if (this.headInfo.orderOtherExpenseAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条其他费用信息",
          type: "error",
        });
        return;
      }
      this.headInfo.orderOtherExpenseAddNewPojoList.splice(index, 1);
      this.resetOrderOtherExpenseItemNo();
    },
    resetOrderOtherExpenseItemNo() {
      let itemNo = 1;
      this.headInfo.orderOtherExpenseAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemOrderOtherExpenseAmountChange();
      this.otherExpenseAmountKey = Math.random();
    },

    // 其他成本相关
    itemOrderOtherCostAmountChange() {
      this.headInfo.otherCostAmount = this.$jsTool.sum(
        this.headInfo.orderOtherCostAddNewPojoList.map(
          (item) => item.itemAmount
        )
      );
    },
    handleHasOtherCostAmount(e) {
      if (e) {
        if (
          !this.headInfo.orderOtherCostAddNewPojoList ||
          this.headInfo.orderOtherCostAddNewPojoList.length == 0
        ) {
          this.headInfo.orderOtherCostAddNewPojoList = [
            {
              itemNo: 1,
              name: null,
              itemAmount: "0.00",
            },
          ];
          this.itemOrderOtherCostAmountChange();
        }
      } else {
        this.headInfo.otherCostAmount = "0.00";
      }
    },
    addOrderOtherCostItem(index) {
      this.headInfo.orderOtherCostAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.orderOtherCostAddNewPojoList[
            this.headInfo.orderOtherCostAddNewPojoList.length - 1
          ].itemNo + 1,
        name: null,
        itemAmount: "0.00",
      });
      this.resetOrderOtherCostItemNo();
    },
    deleteOrderOtherCostItem(index) {
      if (this.headInfo.orderOtherCostAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条其他费用信息",
          type: "error",
        });
        return;
      }
      this.headInfo.orderOtherCostAddNewPojoList.splice(index, 1);
      this.resetOrderOtherCostItemNo();
    },
    resetOrderOtherCostItemNo() {
      let itemNo = 1;
      this.headInfo.orderOtherCostAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemOrderOtherCostAmountChange(this.itemList);
      this.otherCostAmountKey = Math.random();
    },

    // 资金账户相关
    itemFundAccountAmountChange() {
      this.headInfo.settledAmount = this.$jsTool.sum(
        this.headInfo.fundAccountAddNewPojoList.map((item) => item.itemAmount)
      );
    },
    handleHasSettledAmount(e) {
      if (e) {
        if (
          !this.headInfo.fundAccountAddNewPojoList ||
          this.headInfo.fundAccountAddNewPojoList.length == 0
        ) {
          this.headInfo.fundAccountAddNewPojoList = [
            {
              itemNo: 1,
              fundAccountId: null,
              itemAmount: "0.00",
              remark: "",
            },
          ];
          this.$forceUpdate();
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField(
            "collectVoucherSysFileIdList"
          );
        });
        this.itemFundAccountAmountChange();
      } else {
        this.headInfo.settledAmount = "0.00";
      }
    },
    addFundAccountItem(index) {
      this.headInfo.fundAccountAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.fundAccountAddNewPojoList[
            this.headInfo.fundAccountAddNewPojoList.length - 1
          ].itemNo + 1,
        fundAccountId: null,
        itemAmount: "0.00",
        remark: "",
      });
      this.resetFundAccountItemNo();
    },
    deleteFundAccountItem(index) {
      if (this.headInfo.fundAccountAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条现结金额信息",
          type: "error",
        });
        return;
      }
      this.headInfo.fundAccountAddNewPojoList.splice(index, 1);
      this.resetFundAccountItemNo();
    },
    resetFundAccountItemNo() {
      let itemNo = 1;
      this.headInfo.fundAccountAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemFundAccountAmountChange();
    },

    // 收款凭证有关
    collectVoucherFilePreview(index) {
      document.getElementById("collectVoucherImage" + index).click();
    },
    collectVoucherFileDelete(index, file) {
      this.collectVoucherFileList.splice(index, 1);
      this.initCollectVoucherFileList();
    },
    collectVoucherFileChange(file, fileList) {
      if (file.status == "ready") {
        this.collectVoucherFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCollectVoucherFileList();
    },
    collectVoucherFileSuccess(res, file, fileList) {
      let index = this.collectVoucherFileList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.collectVoucherFileList.splice(index, 1, {
          ...this.collectVoucherFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.collectVoucherFileList.splice(index, 1);
      }
      this.initCollectVoucherFileList();
    },
    initCollectVoucherFileList() {
      this.$nextTick(() => {
        this.headInfo.collectVoucherSysFileIdList = this.collectVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField(
          "collectVoucherSysFileIdList"
        );
      });
    },

    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },

    // 单据金额
    changeCommodityBuyingAmount() {
      console.log("headInfo.buyingAmount", this.headInfo.buyingAmount);
      this.headInfo = {
        ...this.headInfo,
        buyingDisCountAmount: this.$jsTool.sub(
          this.headInfo.buyingTotalAmount,
          this.headInfo.buyingAmount
        ),
      };
      // 单据优惠比例
      let disCountRadio = this.$jsTool.divis(
        this.headInfo.buyingDisCountAmount,
        this.headInfo.buyingTotalAmount,
        8
      );
      this.itemList.forEach((item, index) => {
        let curIndex = this.itemList.findIndex((d) => d.itemNo == item.itemNo);
        let buyingDisCountAmount = 0;
        if (index == this.itemList.length - 1) {
          buyingDisCountAmount = this.$jsTool.sub(
            this.headInfo.buyingDisCountAmount,
            this.$jsTool.sum(
              this.itemList
                .filter((d) => d.itemNo != item.itemNo)
                .map((f) => f.buyingDisCountAmount)
            )
          );
        } else {
          buyingDisCountAmount = this.$jsTool.multi(
            disCountRadio,
            item.buyingTotalAmount
          );
        }
        this.itemList.splice(curIndex, 1, {
          ...this.itemList[curIndex],
          itemBuyingAmount: this.$jsTool.sub(
            item.buyingTotalAmount,
            buyingDisCountAmount
          ),
          buyingDisCountAmount: buyingDisCountAmount,
        });
      });
      this.selectCommodity(this.itemList);
    },

    // 编辑行项目
    addItem() {
      let itemNo = 1;
      if (this.itemList && this.itemList.length > 0) {
        itemNo = this.itemList[this.itemList.length - 1].itemNo + 1;
      }
      this.itemList.push({
        ...this.$options.data().editItem,
        itemNo: itemNo,
        extFieldValueAddNewPojoList: JSON.parse(
          JSON.stringify(this.itemExtFieldList || [])
        ),
      });
    },
    deleteItem(index) {
      if (this.itemList.length == 1) {
        this.$message({
          message: "最少保留一条商品信息",
          type: "error",
        });
        return;
      }
      this.itemList.splice(index, 1);
      this.resetOrderOtherCostItemNo();
      this.selectCommodity(this.itemList);
    },

    // 行项目图片
    itemCommodityImageFilePreview(itemNo, index) {
      document
        .getElementById("itemCommodityImage-" + itemNo + "-" + index)
        .click();
    },
    itemCommodityImageFileDelete(itemNo, index, file) {
      let itemIndex = this.itemList.findIndex((d) => d.itemNo == itemNo);
      this.itemList[itemIndex].fileList.splice(index, 1);
      this.initItemCommodityImageFileList(itemNo);
    },
    itemCommodityImageChange(itemNo, file, fileList) {
      let itemIndex = this.itemList.findIndex((d) => d.itemNo == itemNo);
      if (file.status == "ready") {
        this.itemList[itemIndex].fileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initItemCommodityImageFileList(itemNo);
    },
    itemCommodityImageSuccess(itemNo, res, file, fileList) {
      let itemIndex = this.itemList.findIndex((d) => d.itemNo == itemNo);
      let index = this.itemList[itemIndex].fileList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.itemList[itemIndex].fileList.splice(index, 1, {
          ...this.itemList[itemIndex].fileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.itemList[itemIndex].fileList.splice(index, 1);
      }
      this.initItemCommodityImageFileList(itemNo);
    },
    initItemCommodityImageFileList(itemNo) {
      let itemIndex = this.itemList.findIndex((d) => d.itemNo == itemNo);
      if (itemIndex > -1) {
        this.$nextTick(() => {
          this.itemList.splice(itemIndex, 1, {
            ...this.itemList[itemIndex],
            sysFileIdList: this.itemList[itemIndex].fileList
              .filter((d) => d.status == "success")
              .map((d) => d.id),
          });
        });
      }
    },

    async getOrderInfo(args) {
      let res = await this.$api.customizeOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.headVo,
          orderOtherExpenseAddNewPojoList:
            res.data.headVo.orderOtherExpenseList,
          orderOtherCostAddNewPojoList: res.data.headVo.orderOtherCostList,
          fundAccountAddNewPojoList: res.data.headVo.fundAccountList,
          saleUserIdList: res.data.headVo.saleUserList.map((d) => d.userId),
          collectVoucherSysFileIdList:
            res.data.headVo.collectVoucherImageList.map((d) => d.sysFile.id),
          collectRemark: res.data.headVo.collectRemark || "",
          extFieldValueAddNewPojoList: [],
        };
        this.itemList = res.data.itemList.map((d) => {
          let item = d;
          let extFieldValueAddNewPojoList = [];
          // 处理拓展字段
          for (let extFieldItem of this.itemExtFieldList) {
            let value = extFieldItem.value;
            if (item.extFieldValueList && item.extFieldValueList.length > 0) {
              let extFieldValueAddNewIndex = item.extFieldValueList.findIndex(
                (d) => d.code == extFieldItem.code
              );
              let extFieldValueAddNewItem =
                item.extFieldValueList[extFieldValueAddNewIndex];
              if (extFieldValueAddNewIndex > -1) {
                value =
                  extFieldItem.extFieldTypeEnum ==
                    extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                  extFieldItem.extFieldTypeEnum ==
                    extFieldValueAddNewItem.extFieldTypeEnum
                    ? extFieldValueAddNewItem.value
                    : null;
                if (
                  extFieldItem.extFieldTypeEnum == "Checkbox" ||
                  extFieldItem.extFieldTypeEnum.Name == "Checkbox"
                ) {
                  if (value) {
                    if (typeof value == "string") {
                      value = value.split(",");
                    }
                  } else {
                    value = [];
                  }
                }
              }
            }
            extFieldValueAddNewPojoList.push({
              ...JSON.parse(JSON.stringify(extFieldItem)),
              value: value,
            });
          }
          return {
            ...d,
            sysFileIdList: d.fileList.map((d) => d.sysFile.id),
            fileList: d.fileList.map((item) => {
              return {
                imageName: item.sysFile.name,
                id: item.sysFile.id,
                message: "已有图片",
                status: "success",
                thumb: item.sysFile.prefix + item.sysFile.name,
                type: "image",
                url: item.sysFile.prefix + item.sysFile.name,
              };
            }),
            extFieldValueAddNewPojoList: extFieldValueAddNewPojoList,
          };
        });
        this.customer = res.data.headVo.customer;
        this.saleUserList = res.data.headVo.saleUserList.map((d) => d.user);
        if (
          res.data.headVo.fundAccountList &&
          res.data.headVo.fundAccountList.length > 0
        ) {
          this.hasSettledAmount = true;
        }
        if (
          res.data.headVo.orderOtherExpenseList &&
          res.data.headVo.orderOtherExpenseList.length > 0
        ) {
          this.hasOtherExpenseAmount = true;
        }
        if (
          res.data.headVo.orderOtherCostList &&
          res.data.headVo.orderOtherCostList.length > 0
        ) {
          this.hasOtherCostAmount = true;
        }
        this.collectVoucherFileList = res.data.headVo.collectVoucherImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );

        // 拓展字段
        let extFieldValueAddNewPojoList = [];
        for (let extFieldItem of this.extFieldList) {
          let value = extFieldItem.value;
          if (
            res.data.headVo.extFieldValueList &&
            res.data.headVo.extFieldValueList.length > 0
          ) {
            let extFieldValueAddNewIndex =
              res.data.headVo.extFieldValueList.findIndex(
                (d) => d.code == extFieldItem.code
              );
            let extFieldValueAddNewItem =
              res.data.headVo.extFieldValueList[extFieldValueAddNewIndex];
            if (extFieldValueAddNewIndex > -1) {
              value =
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum
                  ? extFieldValueAddNewItem.value
                  : null;
              if (
                extFieldItem.extFieldTypeEnum == "Checkbox" ||
                extFieldItem.extFieldTypeEnum.Name == "Checkbox"
              ) {
                if (value) {
                  if (typeof value == "string") {
                    value = value.split(",");
                  }
                } else {
                  value = [];
                }
              }
            }
          }
          extFieldValueAddNewPojoList.push({
            ...JSON.parse(JSON.stringify(extFieldItem)),
            value: value,
          });
        }
        this.headInfo.extFieldValueAddNewPojoList = extFieldValueAddNewPojoList;

        this.$nextTick(() => {
          setTimeout(() => {
            if (
              this.hasSettledAmount ||
              this.hasOtherExpenseAmount ||
              this.hasOtherCostAmount
            ) {
              this.$forceUpdate();
            }
          }, 200);
        });
      }
    },

    edit(submit) {
      if (!this.hasSettledAmount) {
        this.headInfo.settledAmount = "0.00";
        this.headInfo.fundAccountAddNewPojoList = [];
        this.headInfo.collectVoucherSysFileIdList = [];
        this.headInfo.collectRemark = "";
      } else {
        if (
          this.collectVoucherFileList &&
          this.collectVoucherFileList.length > 0 &&
          this.collectVoucherFileList.filter((d) => d.status == "success")
            .length > 0
        ) {
          this.headInfo.collectVoucherSysFileIdList =
            this.collectVoucherFileList
              .filter((d) => d.status == "success")
              .map((d) => d.id);
        }
      }
      if (!this.hasOtherExpenseAmount) {
        this.headInfo.otherExpenseAmount = "0.00";
        this.headInfo.orderOtherExpenseAddNewPojoList = [];
      }
      if (!this.hasOtherCostAmount) {
        this.headInfo.otherCostAmount = "0.00";
        this.headInfo.orderOtherCostAddNewPojoList = [];
      }
      //  校验拓展字段是否填写
      for (let item of this.headInfo.extFieldValueAddNewPojoList) {
        if (item.requiredMark && item.visible && item.value == null) {
          this.$message({
            message: "请完善拓展字段 " + item.label,
            type: "error",
          });
          return;
        }
      }
      let extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(
          this.headInfo.extFieldValueAddNewPojoList.filter((d) => d.visible)
        )
      );
      for (let item of extFieldValueAddNewPojoList) {
        if (item.extFieldTypeEnum == "Checkbox" && item.value) {
          item.value = item.value.toString();
        }
        item.extFieldId = item.id;
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.customizeOrder_updateAndSubmit(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList.map((d) => {
                    let itemExtFieldValueAddNewPojoList = JSON.parse(
                      JSON.stringify(
                        d.extFieldValueAddNewPojoList.filter((d) => d.visible)
                      )
                    );
                    for (let item of itemExtFieldValueAddNewPojoList) {
                      if (item.extFieldTypeEnum == "Checkbox" && item.value) {
                        item.value = item.value.toString();
                      }
                      item.extFieldId = item.id;
                    }
                    return {
                      ...d,
                      extFieldValueAddNewPojoList:
                        itemExtFieldValueAddNewPojoList,
                    };
                  }),
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.customizeOrder_update(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList.map((d) => {
                    let itemExtFieldValueAddNewPojoList = JSON.parse(
                      JSON.stringify(
                        d.extFieldValueAddNewPojoList.filter((d) => d.visible)
                      )
                    );
                    for (let item of itemExtFieldValueAddNewPojoList) {
                      if (item.extFieldTypeEnum == "Checkbox" && item.value) {
                        item.value = item.value.toString();
                      }
                      item.extFieldId = item.id;
                    }
                    return {
                      ...d,
                      extFieldValueAddNewPojoList:
                        itemExtFieldValueAddNewPojoList,
                    };
                  }),
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.customizeOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList.map((d) => {
                  let itemExtFieldValueAddNewPojoList = JSON.parse(
                    JSON.stringify(
                      d.extFieldValueAddNewPojoList.filter((d) => d.visible)
                    )
                  );
                  for (let item of itemExtFieldValueAddNewPojoList) {
                    if (item.extFieldTypeEnum == "Checkbox" && item.value) {
                      item.value = item.value.toString();
                    }
                    item.extFieldId = item.id;
                  }
                  return {
                    ...d,
                    extFieldValueAddNewPojoList:
                      itemExtFieldValueAddNewPojoList,
                  };
                }),
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.customizeOrder_saveIntoDraft(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList.map((d) => {
                  let itemExtFieldValueAddNewPojoList = JSON.parse(
                    JSON.stringify(
                      d.extFieldValueAddNewPojoList.filter((d) => d.visible)
                    )
                  );
                  for (let item of itemExtFieldValueAddNewPojoList) {
                    if (item.extFieldTypeEnum == "Checkbox" && item.value) {
                      item.value = item.value.toString();
                    }
                    item.extFieldId = item.id;
                  }
                  return {
                    ...d,
                    extFieldValueAddNewPojoList:
                      itemExtFieldValueAddNewPojoList,
                  };
                }),
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizeOrderEditDialog.vue